import { render, staticRenderFns } from "./TableStatsChart.vue?vue&type=template&id=651d0fa9&"
import script from "./TableStatsChart.vue?vue&type=script&lang=js&"
export * from "./TableStatsChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports